
const ArrowIcon = () => (
<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.5 9.5L17.6635 9.5M9.92308 1.42308L18 9.5L9.92308 17.5769" stroke="white" strokeWidth="2"/>
</svg>

);

export default ArrowIcon;
